import { render, staticRenderFns } from "./u-card-gradient.vue?vue&type=template&id=a0092dc8&scoped=true"
import script from "./u-card-gradient.vue?vue&type=script&lang=js"
export * from "./u-card-gradient.vue?vue&type=script&lang=js"
import style0 from "./u-card-gradient.vue?vue&type=style&index=0&id=a0092dc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0092dc8",
  null
  
)

export default component.exports